module.exports = __webpack_public_path__ + "media/src/images/smtx__logo-blue-3281b4f9783d894ce7c4d5840dff4260.svg";